import ParavetListComponent from "./ParavetListComponent";

const ConfigurationParavetSetup = () => {
  return (
    <>
      <ParavetListComponent />
    </>
  );
};

export default ConfigurationParavetSetup;
